import MarketingConsent from "./MarketingConsent";

export default MarketingConsent;
